import { useState, useRef } from 'react';
import '../css/comments.css';

import EmojiPicker from 'emoji-picker-react';
import ImagesAvatar from './ImagesAvatar';

const ReplyForm = ({
  MIN_MESSAGE_LENGTH,
  userInfo,
  formData,
  minMessageReply,
  replyUser,
  setFormData,
  handleSubmit,
  className,
}) => {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const textareaRef = useRef(null);

  const handleInput = (e) => {
    // const editor = editorRef.current;
    // if (!editor) return;

    // const sel = window.getSelection();
    // if (!sel.rangeCount) return;

    // const childNodes = Array.from(editor.childNodes);

    // childNodes.forEach((node) => {
    //   if (node.nodeType === Node.TEXT_NODE) {
    //     const parts = node.textContent.split(/(\s+)/);
    //     parts.forEach((part, index) => {
    //       if (part.startsWith('@')) {
    //         const strong = document.createElement('strong');
    //         strong.textContent = part;
    //         editor.insertBefore(strong, node);
    //       } else if (part.trim() !== '' || index % 2 !== 0) {
    //         const textNode = document.createTextNode(part);
    //         editor.insertBefore(textNode, node);
    //       }
    //     });
    //     editor.removeChild(node);
    //   }
    // });

    // const newRange = document.createRange();
    // newRange.selectNodeContents(editor);
    // newRange.collapse(false);
    // sel.removeAllRanges();
    // sel.addRange(newRange);

    setFormData((prev) => ({
      ...prev,
      content: e,
    }));
  };

  const handleInputComment = (e) => {
    setFormData((prev) => ({
      ...prev,
      content: e.target.value,
    }));

    const el = textareaRef.current;
    el.style.height = '20px';
    el.style.height = el.scrollHeight + 'px';
  };

  const handleEmojiClick = (emojiData) => {
    setFormData((prev) => ({
      ...prev,
      content: prev.content + emojiData.emoji,
    }));
    setShowEmojiPicker(!showEmojiPicker);
  };

  return (
    userInfo && (
      <div className={`d-flex reply-of-cmt  ${className}`}>
        <ImagesAvatar user={userInfo.userInformation} />
        <article className="w-100 ">
          <form className="w-100 reply-form" onSubmit={handleSubmit}>
            <textarea
              ref={textareaRef}
              className="editor"
              placeholder={`Trả lời ${replyUser}`}
              value={formData.content}
              onChange={handleInputComment}
              style={{
                width: '100%',
                border: 'none',
                padding: '0.5rem 0.5rem 0',
                outline: 'none',
                boxShadow: 'none',
                resize: 'none',
                borderRadius: '8px',
                background: 'var(--no-color)',
                lineHeight: '20px',
                minHeight: '20px',
                overflow: 'hidden',
              }}
            ></textarea>
            <div className="d-flex ">
              <button
                type="button"
                onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '20px',
                  marginLeft: '0.5rem',
                  color: 'var(--dark-gray)',
                }}
              >
                <i className="far fa-smile w-100"></i>
              </button>
              {showEmojiPicker && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: '40px',
                    left: '1rem',
                    zIndex: 100,
                  }}
                >
                  <EmojiPicker onEmojiClick={handleEmojiClick} />
                </div>
              )}
              <button type="submit" className="btn-send ms-auto">
                <img
                  src="/images/icons/send.png"
                  alt=""
                  className="icon-send "
                />
              </button>
            </div>
          </form>
          {minMessageReply && (
            <p className="text-danger message-text mt-2">
              Nội dung phải có ít nhất {MIN_MESSAGE_LENGTH} ký tự!
            </p>
          )}
        </article>
      </div>
    )
  );
};

export default ReplyForm;
